package es.cinfo.tiivii.core.modules.geolocation

//TODO: Add to a configuration service
const val LOCATION_UPDATE_INTERVAL_MS = 5000L
const val LOCATION_UPDATE_DISTANCE_METERS = 5F

internal expect class LocationService